import { __decorate, __metadata } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { w } from '@dojo/framework/core/vdom';
import { beforeProperties } from '@dojo/framework/core/decorators/beforeProperties';
import has from '@dojo/framework/core/has';
import { MCQuestionBase } from './mc-base';
import { MCQuestionPretest } from './mc-pretest';
import { MCQuestionPrometric } from './mc-prometric';
import { MCQuestionPearsonVue } from './mc-pearsonvue';
import { MCQuestionAudit } from './mc-audit';
import { PrometricReview } from './review-prometric';
import { PrometricMPEReview } from './review-prometric-mpe';
import { PearsonVueReview } from './review-pearsonvue';
import { PretestReview } from './review-pretest';
export class MCSelector extends I18nThemed {
    _propsInited = false;
    render() {
        const { quizstore, quizkind, progression, inreview = false, isaudit = false, hasNextQuestion, onNextQuestion, hasPreviousQuestion, onPreviousQuestion, onFinish, updater, onReview, getQuestions, filterOn, checkFor = () => true, hasNextSection = () => false, hasReviewed } = this.properties;
        const questionProps = {
            quizstore,
            hasNextQuestion,
            onNextQuestion,
            hasPreviousQuestion,
            onPreviousQuestion,
            onFinish,
            updater,
            onReview,
            hasReviewed
        };
        const prometricAudit = (inreview) => inreview
            ? w(PrometricReview, {
                quizstore,
                getQuestions,
                onFinish,
                filterOn,
                checkFor,
                onReview,
                isaudit: true,
                localizedBundle: { isPlaceholder: true, format: () => '', messages: {} }
            })
            : w(MCQuestionAudit, questionProps);
        const prometricQuiz = (inreview) => inreview
            ? w(PrometricReview, {
                quizstore,
                getQuestions,
                onFinish,
                filterOn,
                checkFor,
                onReview,
                isaudit: false,
                localizedBundle: { isPlaceholder: true, format: () => '', messages: {} }
            })
            : w(MCQuestionPrometric, questionProps);
        const prometricMPEQuiz = (inreview) => inreview
            ? w(PrometricMPEReview, {
                quizstore,
                getQuestions,
                onFinish,
                filterOn,
                checkFor,
                onReview,
                hasNextSection,
                isaudit: false,
                localizedBundle: { isPlaceholder: true, format: () => '', messages: {} }
            })
            : w(MCQuestionPrometric, questionProps);
        const pearsonvueAudit = (inreview) => inreview
            ? w(PearsonVueReview, {
                quizstore,
                getQuestions,
                onFinish,
                filterOn,
                checkFor,
                onReview,
                isaudit: true,
                localizedBundle: { isPlaceholder: true, format: () => '', messages: {} }
            })
            : w(MCQuestionAudit, questionProps);
        const pearsonvueQuiz = (inreview) => inreview
            ? w(PearsonVueReview, {
                quizstore,
                getQuestions,
                onFinish,
                filterOn,
                checkFor,
                onReview,
                isaudit: false,
                localizedBundle: { isPlaceholder: true, format: () => '', messages: {} }
            })
            : w(MCQuestionPearsonVue, questionProps);
        const qfAudit = (inreview) => inreview
            ? w(PretestReview, {
                quizstore,
                getQuestions,
                onFinish,
                filterOn,
                checkFor,
                onReview,
                isaudit: false,
                localizedBundle: { isPlaceholder: true, format: () => '', messages: {} }
            })
            : w(MCQuestionAudit, questionProps);
        const pretestQuiz = () => w(MCQuestionPretest, questionProps);
        switch (quizkind) {
            case 'section':
                return isaudit ? qfAudit(inreview) : w(MCQuestionBase, questionProps);
            case 'pretest':
                return isaudit ? qfAudit(inreview) : pretestQuiz();
            case 'posttest':
            case 'practice':
                if (has('use-posttest-forward-progression')) {
                    return isaudit ? qfAudit(inreview) : pretestQuiz();
                }
                switch (progression) {
                    case 'prometric-mpe':
                        return isaudit ? prometricAudit(inreview) : prometricMPEQuiz(inreview);
                    case 'prometric':
                        return isaudit ? prometricAudit(inreview) : prometricQuiz(inreview);
                    case 'pearson-vue':
                        return isaudit ? pearsonvueAudit(inreview) : pearsonvueQuiz(inreview);
                    default:
                        return isaudit ? qfAudit(inreview) : w(MCQuestionBase, questionProps);
                }
            default:
                return w(MCQuestionBase, questionProps);
        }
    }
    stateProperties(properties) {
        const { quizstore } = properties;
        const { get, path } = quizstore;
        if (!this._propsInited) {
            const paths = [['quiz'], ['progression']];
            const invalidatePaths = paths.map((path) => quizstore.path(path.join('/')));
            const handle = quizstore.onChange(invalidatePaths, () => this.invalidate());
            this.own({
                destroy: () => {
                    handle.remove();
                }
            });
            this._propsInited = true;
        }
        properties.quizkind = get(path('quiz')).kind;
        properties.progression = get(path('progression'));
        return properties;
    }
}
__decorate([
    beforeProperties(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Object)
], MCSelector.prototype, "stateProperties", null);
export default MCSelector;
